export default __webpack_public_path__ + "static/media/neighborhoods_merged.aa16f696.geojson";